import error from '../assets/img/error.png';

const picsLibrary = {
  error,
};

export default picsLibrary;